import axios from 'axios'
import { getItem, removeAll } from './storage'
import { getUserToken } from './auth'
import { warning } from './message'
import router from '../router'
const CONFIG = require('@/utils/config')

// import { notifyWarning } from './message'
// import { getCommonHeaders } from 'src/api/server/common'

// 创建axios实例
const service = axios.create({
  baseURL: '',
  timeout: 120000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(config => {
  const baseURL = CONFIG.BASE_URL + '/api'
  config.url = `${baseURL}${config.url}`

  // Token
  const token = getUserToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  let locale = getItem('locale')
  if (locale) {
    config.params.local = locale
  }

  // Headers
  // let headers = getCommonHeaders()
  // notifyWarning('headers: ' + JSON.stringify(headers), 'top', 5000)
  // config.headers = Object.assign(config.headers, headers)

  // sign
  // if (config.url.indexOf('/user/identity') >= 0 || config.url.indexOf('/mining') >= 0) {
  //   let result = computeSign(config)
  //   config.headers = Object.assign(config.headers, result)
  //   // console.log('use sign', result, config.headers)
  // }

  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    let data = response.data
    if (data.status === 4030) {
      console.log('未登陆')
      // store.dispatch('CLEAN_USERINFO')
      // console.log('resignin')
      // router.push('/auth/signin')
    }

    return data
  },
  error => {
    console.log('err', error)
    let code = error.response.status
    if (code === 401) {
      removeAll()
      warning('请登陆后操作')
      router.push('/login')
    }
    let message = error.message
    if (message.indexOf('Network Error') >= 0) {
      message = '' // Network Error, please retry
      // store.dispatch('A_AUTOCONFIG_APS')
    } else if (message.indexOf('timeout') >= 0) {
      message = '' // Timeout, please retry
      // store.dispatch('A_AUTOCONFIG_APS')
    }
    // if (message) notifyWarning(message, 'bottom')
    return Promise.reject(error)
  })

export default service
